import React from 'react'
import PlaySVG from '../../shared/icons/PlaySVG'

const HomeHero = ({ heroData }) => {
  const {
    backgroundImage,
    buttonText,
    buttonColor,
    buttonFontColor,
    playButtonDisplayed,
    detail,
    detailColor,
    detailFontSize,
    slogan,
    sloganColor,
    sloganFontSize,
    sloganLine2,
    videoLink,
  } = heroData

  return (
    <section className="dealmed-home-hero" aria-labelledby="dealmed-home-hero-heading">
      <div className="dealmed-container">
        <img
          src={backgroundImage.fields.file.url}
          className="dealmed-home-hero__image"
          alt=""
          loading="lazy"
        />

        <div className="dealmed-home-hero__content">
          <div className="dealmed-container">
            <div id="homepage-hero-text-container">
              <h2
                className="dealmed-home-hero__heading"
                id="dealmed-home-hero-heading"
                style={{ fontSize: `${sloganFontSize}`, color: `${sloganColor}` }}
              >
                {slogan} <span className="dealmed-home-hero__heading-span">{sloganLine2}</span>
              </h2>
              <p
                className="dealmed-home-hero__text"
                style={{ fontSize: `${detailFontSize}`, color: `${detailColor}` }}
              >
                {detail}
              </p>
            </div>
            <a
              href={`${videoLink}`}
              className="dealmed-home-hero__link"
              id="home-hero-button"
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: `${buttonColor}`, color: `${buttonFontColor}` }}
            >
              {playButtonDisplayed && (
                <span
                  className="dealmed-home-hero__icon-wrapper"
                  style={{ color: `${buttonFontColor}` }}
                >
                  <PlaySVG className="dealmed-home-hero__icon" />
                </span>
              )}
              {buttonText}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeHero
